<template>
  <div>
    <b-overlay
      id="overlay-background"
      :show="loader === true"
      variant="dark"
      opacity="0.85"
      blur="2px"
      rounded="sm"
      spinner-variant="primary"
      spinner-medium
    >
      <!-- Table Container Card -->
      <b-card
        no-body
        class="mb-0"
      >
        <div class="m-2">
          <b-row>
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>{{ $t('DEBTIA_SHOWING') }}</label>
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :clearable="false"
                class="search_by_select per-page-selector d-inline-block mx-50"
                :options="perPageOptions"
              />
              <label>{{ $t('DEBTIA_ENTRIES') }}</label>
            </b-col>
            <b-col
              cols="12"
              md="6"
              class="query-input"
            >
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                  v-model="searchQuery"
                  class="d-inline-block mr-1"
                  :placeholder="$t('DEBTIA_SEARCH')"
                />

                <b-button
                  v-b-modal.modal-role-cases
                  variant="primary"
                  @click="addCase(addCaseInput)"
                >
                  <span class="text-nowrap">{{ $t('DEBTIA_ADD_CASE') }}</span>
                </b-button>
              </div>
            </b-col>
          </b-row>
        </div>
        <b-table
          ref="refUserListTable"
          class="position-relative"
          responsive
          selectable
          :fields="tableFields"
          :select-mode="selectMode"
          :items="casesData"
          hover
          @row-selected="onRowSelected"
        >
          <template #cell(base_type)="data">
            {{ (data.item.base_type) ? data.item.base_type.name : '' }}
          </template>
          <template #cell(status)="data">
            <b-badge
              v-if="data.item.status === 3"
              pill
              variant="danger"
            >
              {{ $t('DEBTIA_TERMINATED') }}
            </b-badge>
            <b-badge
              v-if="data.item.status === 2"
              pill
              variant="danger"
            >
              {{ $t('DEBTIA_DECLINED') }}
            </b-badge>
            <b-badge
              v-if="data.item.status === 1"
              pill
              variant="success"
            >
              {{ $t('DEBTIA_ACCEPTED') }}
            </b-badge>
            <b-badge
              v-if="data.item.status === 0 || data.item.status === null"
              pill
              variant="warning"
            >
              {{ $t('DEBTIA_PENDING') }}
            </b-badge>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">{{ $t('DEBTIA_SHOWING') }} {{ from }} to {{ to }} of {{ totalPages }} {{ $t('DEBTIA_ENTRIES') }}</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalPages"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>

            </b-col>

          </b-row>
        </div>
        <cases-modal
          :modal-loads="modalLoader"
          :reload-method="getCases"
          :default-currency="defaultCurrency"
        />
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BCard, BOverlay, BTable, BRow, BCol, BFormInput, BButton, BPagination, BBadge,
} from 'bootstrap-vue'
import axios from '@axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
import constants from '@/app-configs/constants'
import i18n from '@/libs/i18n'
import Ripple from 'vue-ripple-directive'
import CasesModal from './CasesModal.vue'

export default {
  components: {
    BCard,
    BOverlay,
    BTable,
    BRow,
    BCol,
    vSelect,
    BFormInput,
    BButton,
    BBadge,
    BPagination,
    CasesModal,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      loader: false,
      casesData: [],
      perPage: 10,
      perPageOptions: [10, 25, 50, 100],
      searchQuery: '',
      totalPages: 0,
      from: 0,
      to: 0,
      currentPage: 1,
      editData: {},
      addCaseInput: {
        id: 0,
        name: '',
        description: '',
        user_id: JSON.parse(localStorage.getItem('userData')).data.id,
      },
      caseId: 0,
      user_type: JSON.parse(localStorage.getItem('userData')).data.user_type,
      modalLoader: true,
      constants,
      isSuperAdmin: false,
      wordFile: false,
      finalStep: false,
      showVariables: false,
      busy: false,
      clicked: false,
      searchRun: false,
      selectMode: 'single',
      defaultCurrency: '',
      selected: [],
    }
  },
  computed: {
    tableFields() {
      let fields = []
      fields = [
        { key: 'id', sortable: true },
        { key: 'base_type', sortable: true, label: i18n.t('DEBTIA_BASE_TYPE') },
        { key: 'status', label: i18n.t('DEBTIA_STATUS') },
      ]
      return fields
    },
  },
  watch: {
    searchQuery: {
      handler() {
        this.getCases()
      },
    },
    currentPage: {
      handler() {
        this.getCases()
      },
    },
    perPage: {
      handler() {
        this.currentPage = 1
        this.getCases()
      },
    },
  },
  created() {
    this.getCases()
  },
  methods: {
    onRowSelected(item) {
      this.selected = item
      this.$router.push(`/cases/details/${item['0'].id}`)
    },
    searchRecords() {
      if (this.searchQuery.length > 0) {
        this.searchRun = true
        this.getCases()
      }
    },
    async getSettings() {
      try {
        const cases = await axios.get('/user-settings/get?key=default_currency')
        if (cases.status) {
          this.defaultCurrency = 'DKK'
          if (cases.data.data) {
            this.defaultCurrency = cases.data.data.value
          }
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Error',
            icon: 'CoffeeIcon',
            variant: 'danger',
            text: error,
          },
        })
      }
    },
    async getCases() {
      try {
        if (this.user_type === 'super-admin') {
          this.isSuperAdmin = true
        } else {
          this.isSuperAdmin = false
        }
        this.loader = true
        const cases = await axios.get(`${constants.baseUrl}/get-debt-cases-list?perPage=${this.perPage}&q=${this.searchQuery}&page=${this.currentPage}&sortDesc=true`)
        this.loader = false
        if (cases.status) {
          this.casesData = cases.data.data.data
          this.totalPages = cases.data.data.total
          this.from = cases.data.data.from
          this.to = cases.data.data.to
          this.currentPage = cases.data.data.current_page
          this.loader = false
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Error',
            icon: 'CoffeeIcon',
            variant: 'danger',
            text: error,
          },
        })
      }
    },
    caseDetails(id) {
      this.busy = true
      this.caseId = id
    },
    addCase(item) {
      this.modalLoader = true
      this.wordFile = !this.wordFile
      this.finalStep = !this.finalStep
      this.showVariables = !this.showVariables
      this.editData = item
      this.modalLoader = false
      this.clicked = !this.clicked
      this.getSettings()
    },
    async deleteCase(id) {
      this.loader = true
      const cases = await axios.post(`${constants.baseUrl}/cases/delete`,
        { caseID: id })
      if (cases.status) {
        this.getCases()
      }
      this.loader = false
    },
    actionColumn() {
      if (this.$ability.cannot(this.constants.action.permissionLetterTemplateEdit, this.constants.resource.letterTemplate) && this.$ability.cannot(this.constants.action.permissionLetterTemplateDelete, this.constants.resource.letterTemplate)) {
        if (this.user_type !== 'super-admin') {
          this.tableFields.splice(2, 1)
        } else {
          this.tableFields.splice(3, 1)
        }
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.search_by_select .vs__dropdown-toggle{
  width: 160px;
}
</style>
